/**
 * éä»¶ä¿¡æ¯å®ä¹
 */
interface AttachmentInfo {

  /**
   * éä»¶id
   */
  attachmentId: string;

  /**
   * éä»¶åç§°
   */
  fileName: string;
}


/**
 * æå¡å¨ç«¯æéçéä»¶ä¿¡æ¯å®ä¹
 */
interface ServerAttachmentInfo {

  /**
   * è¡¨åè·¯å¾
   */
  NodeCodes: string[];

  /**
   * ä¸»é®è·¯å¾
   */
  HiretryIds: string[];

  /**
   * éä»¶idæ°ç»ï¼æ¹éæ°å¢æ¶ä½¿ç¨ï¼
   */
  AttachmentIds?: string[];

  /**
   * éä»¶idï¼æ´æ°æ¶ä½¿ç¨ï¼
   */
  AttachmentId?: string;
}
/**
 * éä»¶udtæåºå­æ®µ
 */
const ATTACHMENT_ORDER_FIELD = 'fileSortOrder';

export { AttachmentInfo, ServerAttachmentInfo, ATTACHMENT_ORDER_FIELD };
